import { useCallback, useSyncExternalStore } from "react";
import { clearNationalCache, loadNational, type NationalData } from "./national";
import { useQuery, type QueryState } from "./useQuery";

// Several components on one page read the file. A retry from any of them bumps this shared version
// so that all of them refetch (the fetch itself is shared through `loadNational`'s cached promise).
let version = 0;
const listeners = new Set<() => void>();

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/** The national overview file, loaded once per page load and shared by the public pages. */
export function useNational(): QueryState<NationalData> {
  const v = useSyncExternalStore(
    subscribe,
    () => version,
    () => version,
  );
  const query = useQuery(`national:${v}`, () => loadNational());
  const reload = useCallback(() => {
    clearNationalCache();
    version += 1;
    listeners.forEach((l) => l());
  }, []);
  return { ...query, reload };
}
